import authController from '../auth/controller.js';

export default class AuthStep {
    constructor() {
        this.id = 'auth';
        this.title_key = 'login';
    }

    init({ $, state, data, emit, api }) {
        this.$ = $;
        this.state = state; // bwState
        this.data = data;   // bwData
        this.emit = emit;

        this.authFlow = authController({
            $, api,
            state,
            authData: data.auth || {}, // only what is required for auth
            routes: data.apiRoutes || {}, // TODO: get only specific auth routes
            onComplete: (user) => this.next(user),
            onSocialRedirect: () => this.emit('save_state')
        });
    }

    render(container) {
        const $wrapper = this.$(`<div class="step-main-row auth-step active"
            data-international="${this.data.allow_international ? 'true' : 'false'}"
            data-skip-user="${this.data.skip_user === 'Y' ? 'true' : 'false'}"></div>`);

        container.html($wrapper);
        this.authFlow.render($wrapper);
    }

    next(user) {
        // O singură dată pe randare: două răspunsuri la login (dublu-tap pe iPhone, reflexovital
        // 29 oct) făceau app.js să avanseze de două ori, peste pasul de servicii.
        if (this.finished) {
            return;
        }
        this.finished = true;
        this.state.user = user;
        this.emit('auth_finish_event', { user });
    }
};
